import React, { useState } from 'react';

const T: Record<string, { flag: string; label: string; nav_home: string; nav_orders: string; nav_settings: string; greeting: string; subtitle: string; stat1_val: string; stat1_label: string; stat2_val: string; stat2_label: string; stat3_val: string; stat3_label: string; recent: string; order1: string; order1_status: string; order2: string; order2_status: string; order3: string; order3_status: string; btn: string }> = {
  en: { flag: '🇬🇧', label: 'English', nav_home: 'Home', nav_orders: 'Orders', nav_settings: 'Settings', greeting: 'Good morning, Sarah', subtitle: 'Here\'s what\'s happening with your store today.', stat1_val: '$12,847', stat1_label: 'Revenue this month', stat2_val: '284', stat2_label: 'Orders this week', stat3_val: '4.9★', stat3_label: 'Customer rating', recent: 'Recent Orders', order1: 'Wireless Headphones', order1_status: 'Shipped', order2: 'Laptop Stand', order2_status: 'Processing', order3: 'USB-C Hub', order3_status: 'Delivered', btn: 'View All Orders' },
  es: { flag: '🇪🇸', label: 'Español', nav_home: 'Inicio', nav_orders: 'Pedidos', nav_settings: 'Ajustes', greeting: 'Buenos días, Sarah', subtitle: 'Esto es lo que está pasando con tu tienda hoy.', stat1_val: '$12.847', stat1_label: 'Ingresos este mes', stat2_val: '284', stat2_label: 'Pedidos esta semana', stat3_val: '4.9★', stat3_label: 'Valoración de clientes', recent: 'Pedidos Recientes', order1: 'Auriculares Inalámbricos', order1_status: 'Enviado', order2: 'Soporte para Portátil', order2_status: 'Procesando', order3: 'Hub USB-C', order3_status: 'Entregado', btn: 'Ver Todos los Pedidos' },
  ja: { flag: '🇯🇵', label: '日本語', nav_home: 'ホーム', nav_orders: '注文', nav_settings: '設定', greeting: 'おはようございます、Sarah', subtitle: '本日のストアの状況です。', stat1_val: '$12,847', stat1_label: '今月の売上', stat2_val: '284', stat2_label: '今週の注文', stat3_val: '4.9★', stat3_label: '顧客評価', recent: '最近の注文', order1: 'ワイヤレスヘッドホン', order1_status: '発送済み', order2: 'ノートPCスタンド', order2_status: '処理中', order3: 'USB-Cハブ', order3_status: '配達済み', btn: 'すべての注文を見る' },
  ar: { flag: '🇸🇦', label: 'العربية', nav_home: 'الرئيسية', nav_orders: 'الطلبات', nav_settings: 'الإعدادات', greeting: 'صباح الخير، سارة', subtitle: 'إليك ما يحدث في متجرك اليوم.', stat1_val: '$١٢٬٨٤٧', stat1_label: 'إيرادات هذا الشهر', stat2_val: '٢٨٤', stat2_label: 'طلبات هذا الأسبوع', stat3_val: '٤.٩★', stat3_label: 'تقييم العملاء', recent: 'الطلبات الأخيرة', order1: 'سماعات لاسلكية', order1_status: 'تم الشحن', order2: 'حامل لابتوب', order2_status: 'قيد المعالجة', order3: 'موزع USB-C', order3_status: 'تم التوصيل', btn: 'عرض جميع الطلبات' },
  de: { flag: '🇩🇪', label: 'Deutsch', nav_home: 'Start', nav_orders: 'Bestellungen', nav_settings: 'Einstellungen', greeting: 'Guten Morgen, Sarah', subtitle: 'So läuft es heute in deinem Shop.', stat1_val: '12.847 $', stat1_label: 'Umsatz diesen Monat', stat2_val: '284', stat2_label: 'Bestellungen diese Woche', stat3_val: '4.9★', stat3_label: 'Kundenbewertung', recent: 'Letzte Bestellungen', order1: 'Kabellose Kopfhörer', order1_status: 'Versendet', order2: 'Laptop-Ständer', order2_status: 'In Bearbeitung', order3: 'USB-C-Hub', order3_status: 'Zugestellt', btn: 'Alle Bestellungen' },
  zh: { flag: '🇨🇳', label: '中文', nav_home: '首页', nav_orders: '订单', nav_settings: '设置', greeting: '早上好，Sarah', subtitle: '以下是您店铺今天的情况。', stat1_val: '$12,847', stat1_label: '本月收入', stat2_val: '284', stat2_label: '本周订单', stat3_val: '4.9★', stat3_label: '客户评分', recent: '最近订单', order1: '无线耳机', order1_status: '已发货', order2: '笔记本支架', order2_status: '处理中', order3: 'USB-C 集线器', order3_status: '已送达', btn: '查看所有订单' },
  pt: { flag: '🇧🇷', label: 'Português', nav_home: 'Início', nav_orders: 'Pedidos', nav_settings: 'Configurações', greeting: 'Bom dia, Sarah', subtitle: 'Veja o que está acontecendo na sua loja hoje.', stat1_val: 'R$12.847', stat1_label: 'Receita este mês', stat2_val: '284', stat2_label: 'Pedidos esta semana', stat3_val: '4.9★', stat3_label: 'Avaliação dos clientes', recent: 'Pedidos Recentes', order1: 'Fones Sem Fio', order1_status: 'Enviado', order2: 'Suporte para Notebook', order2_status: 'Processando', order3: 'Hub USB-C', order3_status: 'Entregue', btn: 'Ver Todos os Pedidos' },
};

const LANG_KEYS = Object.keys(T);

/*
 * Order-status colours come from CSS, not from here.
 *
 * They were inline hex values — #10B981, #F59E0B, #2563EB — which as small bold text
 * on the mock app's surface measured 2.54:1, 2.15:1 and 2.84:1. Darkening them fixes
 * light mode and breaks dark mode, because the surface underneath flips: a colour
 * dark enough to carry on white is too dark on #1F2937. One value cannot satisfy
 * both, so the choice belongs in CSS where it can vary by theme.
 */
const statusClass = (i: number) =>
  ['ld-status--shipped', 'ld-status--processing', 'ld-status--delivered'][i] || '';

const MiniApp: React.FC<{ lang: string }> = ({ lang }) => {
  const t = T[lang];
  const isRtl = lang === 'ar';
  const orders = [
    { name: t.order1, status: t.order1_status, price: '$79.99', ci: 0 },
    { name: t.order2, status: t.order2_status, price: '$34.99', ci: 1 },
    { name: t.order3, status: t.order3_status, price: '$24.99', ci: 2 },
  ];

  return (
    <div className="ld-app" style={{ direction: isRtl ? 'rtl' : 'ltr' }}>
      {/* Sidebar */}
      <div className="ld-sidebar">
        <div className="ld-sidebar-logo">◆</div>
        <div className="ld-sidebar-item ld-sidebar-active">{t.nav_home}</div>
        <div className="ld-sidebar-item">{t.nav_orders}</div>
        <div className="ld-sidebar-item">{t.nav_settings}</div>
      </div>
      {/* Main */}
      <div className="ld-main">
        <div className="ld-greeting">{t.greeting}</div>
        <div className="ld-subtitle">{t.subtitle}</div>
        {/* Stats */}
        <div className="ld-stats">
          {[{ v: t.stat1_val, l: t.stat1_label }, { v: t.stat2_val, l: t.stat2_label }, { v: t.stat3_val, l: t.stat3_label }].map((s, i) => (
            <div className="ld-stat" key={i}>
              <div className="ld-stat-val">{s.v}</div>
              <div className="ld-stat-label">{s.l}</div>
            </div>
          ))}
        </div>
        {/* Orders table */}
        <div className="ld-table-header">{t.recent}</div>
        <div className="ld-table">
          {orders.map((o, i) => (
            <div className="ld-row" key={i}>
              <span className="ld-row-name">{o.name}</span>
              <span className="ld-row-price">{o.price}</span>
              <span className={`ld-row-status ${statusClass(o.ci)}`}>{o.status}</span>
            </div>
          ))}
        </div>
        <div className="ld-table-btn">{t.btn}</div>
      </div>
    </div>
  );
};

export const LiveDemo: React.FC = React.memo(() => {
  const [lang, setLang] = useState('es');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleSelect = (code: string) => {
    setLang(code);
    setDropdownOpen(false);
  };

  return (
    <div className="hero-live-demo">
      {/* Before */}
      <div className="demo-side">
        <div className="demo-label demo-label-before">Before — English only</div>
        <div className="demo-frame">
          <MiniApp lang="en" />
        </div>
      </div>

      <div className="demo-arrow-col"><div className="demo-arrow-icon">→</div></div>

      {/* After */}
      <div className="demo-side">
        <div className="demo-label demo-label-after">After — try the dropdown ↗</div>
        <div className="demo-frame demo-frame-after">
          <div className="demo-lang-bar">
            <div className="demo-lang-dropdown-wrapper">
              <button
                className="demo-lang-trigger demo-pulse"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                {T[lang].flag} {T[lang].label} ▾
              </button>
              {dropdownOpen && (
                <div className="demo-lang-menu">
                  {LANG_KEYS.map(code => (
                    <button key={code} className={`demo-lang-option${code === lang ? ' active' : ''}`} onClick={() => handleSelect(code)}>
                      {T[code].flag} {T[code].label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
          <MiniApp lang={lang} />
        </div>
      </div>
    </div>
  );
});
